import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { StackItem } from '@optimus-web/core';
import { presence } from '../../validation';
import { DropzoneField } from '../reduxFields';

const FIELD_NAME = 'files';

export const FileForm = ({
    accept,
    required,
}: Pick<React.ComponentProps<typeof DropzoneField>, 'accept' | 'required'>) => (
    <StackItem grow>
        <DropzoneField
            name={FIELD_NAME}
            label={<LocalizedText textKey={TextKey.File} />}
            accept={accept}
            required={required}
        />
    </StackItem>
);

export const constraints = {
    [FIELD_NAME]: { presence },
};
